import { ChangeDetectionStrategy, Component, inject, input, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { FolderDto, GalleryDto } from '@nusign/picflow-backend-types';
import { DashboardDragDropService } from '../../../services/dashboard-drag-drop.service';
import { GalleryDisplayPreferencesService } from '../../../services/gallery-display-preferences.service';
import { GalleryItemComponent } from '../../../shared-extra/components/gallery-item/gallery-item.component';
import { DragItemDirective } from '../../../shared/components/drag-drop/drag-item.directive';
import { GalleriesSortByPipe } from '../../../shared/pipes/galleries-sort-by.pipe';
import { GalleryItemActiveComponent } from '../gallery-item-active/gallery-item-active.component';
import { GalleryListItemComponent } from '../gallery-list-item/gallery-list-item.component';

@Component({
  selector: 'app-list-galleries',
  templateUrl: './list-galleries.component.html',
  styleUrls: ['./list-galleries.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    GalleryItemActiveComponent,
    GalleryListItemComponent,
    GalleriesSortByPipe,
    DragItemDirective,
    GalleryItemComponent,
    RouterLink,
  ],
})
export class ListGalleriesComponent {
  private dashboardDragDropService = inject(DashboardDragDropService);
  private galleryDisplayPreferencesService = inject(GalleryDisplayPreferencesService);
  galleryDisplayPreferences = toSignal(this.galleryDisplayPreferencesService.displayPreferences$);
  folder = input<FolderDto>();
  galleries = input.required<GalleryDto[]>();
  dontSort = input<boolean>();
  center = input(false);
  dragging = signal<string>(undefined);
  linkGenerator = input<(folder: GalleryDto) => string>(undefined);
  target = input<string>('');
  publicMode = input<boolean>(false);

  setDragging(gallery: GalleryDto, dragging: boolean) {
    if (dragging) {
      this.dragging.set(gallery.id);
    } else {
      if (this.dragging() === gallery.id) {
        this.dragging.set(undefined);
      }
    }
  }

  dropped(data: { id: string; target: string; targetType: string; context: string }) {
    const gallery = this.galleries().find(g => g.id === data.id);
    this.dashboardDragDropService.dropGallery(gallery, data);
  }
}
